import React from 'react';
import SubmitResetButtons from '../FormControl/SubmitResetButtons';
import ApiValidationErrorDisplay from '../ApiValidationErrorDisplay';
import PropTypes from 'prop-types';

function SubmitResetButtonAndValidationError({
    isSubmitting,
    handleSubmit,
    setResetCount,
    resetForm,
    navTitles,
    setNavTitles,
    apiValidationErrors,
    clearApiValidationErrors,
    isValid,
    submitCount,
    alertSwal,
}) {
    React.useEffect(() => {
        if (submitCount === 0) return;
        if (!isValid && alertSwal) {
            alertSwal('warning', 'There is error in your form. Please fix it and try again.');
        }
    }, [submitCount, isValid]);

    return (
        <>
            <SubmitResetButtons
                isSubmitting={isSubmitting}
                handleSubmit={handleSubmit}
                setResetCount={setResetCount}
                resetForm={resetForm}
                navTitles={navTitles}
                setNavTitles={setNavTitles}
            />
            <ApiValidationErrorDisplay
                errors={apiValidationErrors}
                clearError={clearApiValidationErrors}
            />
        </>
    );
}

SubmitResetButtonAndValidationError.defaultProps = {
    navTitles: [],
    setResetCount: null,
    setNavTitles: null,
    errors: {},
    alertSwal: null,
};

SubmitResetButtonAndValidationError.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    setResetCount: PropTypes.func,
    resetForm: PropTypes.func.isRequired,
    navTitles: PropTypes.array,
    setNavTitles: PropTypes.func,
    apiValidationErrors: PropTypes.array.isRequired,
    clearApiValidationErrors: PropTypes.func.isRequired,
    errors: PropTypes.object,
    isValid: PropTypes.bool.isRequired,
    submitCount: PropTypes.number.isRequired,
    alertSwal: PropTypes.func,
};
export default SubmitResetButtonAndValidationError;
